import { Phone, MessageCircle } from "lucide-react";

export default function FloatingActions() {
  const phone = "+919821237924";
  const wa = `https://wa.me/919821237924?text=${encodeURIComponent("Hi Samota Insurance, I'd like to know more.")}`;
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={wa}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        aria-label="WhatsApp"
        className="group inline-flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500 hover:bg-emerald-600 text-white shadow-lg shadow-emerald-500/30 transition"
      >
        <MessageCircle className="h-6 w-6" />
      </a>
      <a
        href={`tel:${phone}`}
        data-testid="floating-call"
        aria-label="Call now"
        className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-blue-900 hover:bg-blue-950 text-white shadow-lg shadow-blue-900/30 transition"
      >
        <Phone className="h-6 w-6" />
      </a>
    </div>
  );
}
